import React, { useState, useRef, useEffect } from 'react';
import NavigationMenu from '../components/NavigationMenu';
import LogoBlanc from '../components/LogoBlanc';
import './LaboratoireSymbiotique.css';

const LaboratoireSymbiotique = () => {
  const [selectedExperiment, setSelectedExperiment] = useState(null);
  const [hoveredExperiment, setHoveredExperiment] = useState(null);
  const [highlightedSeries, setHighlightedSeries] = useState(null);
  const [displayedImage, setDisplayedImage] = useState(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [isDashboardOpen, setIsDashboardOpen] = useState(false); // Nouveau state pour le tableau de bord
  const carouselRef = useRef(null);
  const scrollbarRef = useRef(null);

  // Données d'exemple - structure scientifique
  const experiments = [
    {
      id: 1,
      series: '001',
      sample: 'A',
      image: '/media/experimentations/001-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      // context: 'Exploration des structures biologiques à partir de générateurs de particules TouchDesigner. Cette série investigate l\'hybridation entre formes organiques numériques et structures cellulaires naturelles.',
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      // promptText: 'organic membrane, cellular structure, translucent bio-material, flowing particles, abstract TouchDesigner aesthetic, purple and blue gradient',
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 2,
      series: '001',
      sample: 'B',
      image: '/media/experimentations/001-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 3,
      series: '001',
      sample: 'C',
      image: '/media/experimentations/001-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 4,
      series: '002',
      sample: 'A',
      image: '/media/experimentations/002-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 5,
      series: '002',
      sample: 'B',
      image: '/media/experimentations/002-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 6,
      series: '003',
      sample: 'A',
      image: '/media/experimentations/002-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 7,
      series: '003',
      sample: 'A',
      image: '/media/experimentations/003-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 8,
      series: '003',
      sample: 'B',
      image: '/media/experimentations/003-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 9,
      series: '004',
      sample: 'A',
      image: '/media/experimentations/004-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 10,
      series: '004',
      sample: 'B',
      image: '/media/experimentations/004-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 11,
      series: '004',
      sample: 'C',
      image: '/media/experimentations/004-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 12,
      series: '004',
      sample: 'D',
      image: '/media/experimentations/004-D.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 13,
      series: '005',
      sample: 'A',
      image: '/media/experimentations/005-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 14,
      series: '005',
      sample: 'B',
      image: '/media/experimentations/005-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 15,
      series: '005',
      sample: 'C',
      image: '/media/experimentations/005-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 16,
      series: '006',
      sample: 'A',
      image: '/media/experimentations/006-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 17,
      series: '006',
      sample: 'B',
      image: '/media/experimentations/006-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 18,
      series: '006',
      sample: 'C',
      image: '/media/experimentations/006-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 19,
      series: '007',
      sample: 'A',
      image: '/media/experimentations/007-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 20,
      series: '007',
      sample: 'B',
      image: '/media/experimentations/007-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 21,
      series: '007',
      sample: 'C',
      image: '/media/experimentations/007-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
     {
      id: 22,
      series: '007',
      sample: 'D',
      image: '/media/experimentations/007-D.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 23,
      series: '008',
      sample: 'A',
      image: '/media/experimentations/008-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 24,
      series: '00B',
      sample: 'B',
      image: '/media/experimentations/008-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 25,
      series: '008',
      sample: 'C',
      image: '/media/experimentations/008-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 26,
      series: '008',
      sample: 'D',
      image: '/media/experimentations/008-D.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 27,
      series: '009',
      sample: 'A',
      image: '/media/experimentations/009-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 28,
      series: '009',
      sample: 'B',
      image: '/media/experimentations/009-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 29,
      series: '009',
      sample: 'C',
      image: '/media/experimentations/009-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 30,
      series: '010',
      sample: 'A',
      image: '/media/experimentations/010-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
{
      id: 31,
      series: '010',
      sample: 'B',
      image: '/media/experimentations/010-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 32,
      series: '010',
      sample: 'C',
      image: '/media/experimentations/010-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 33,
      series: '011',
      sample: 'A',
      image: '/media/experimentations/011-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 34,
      series: '011',
      sample: 'B',
      image: '/media/experimentations/011-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 35,
      series: '011',
      sample: 'C',
      image: '/media/experimentations/011-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 36,
      series: '011',
      sample: 'D',
      image: '/media/experimentations/011-D.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 37,
      series: '012',
      sample: 'A',
      image: '/media/experimentations/012-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 38,
      series: '012',
      sample: 'B',
      image: '/media/experimentations/012-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 39,
      series: '012',
      sample: 'C',
      image: '/media/experimentations/012-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 40,
      series: '012',
      sample: 'D',
      image: '/media/experimentations/012-D.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 41,
      series: '012',
      sample: 'E',
      image: '/media/experimentations/012-G.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 42,
      series: '012',
      sample: 'G',
      image: '/media/experimentations/012-G.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 43,
      series: '013',
      sample: 'A',
      image: '/media/experimentations/013-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 44,
      series: '013',
      sample: 'B',
      image: '/media/experimentations/013-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 45,
      series: '013',
      sample: 'C',
      image: '/media/experimentations/013-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 46,
      series: '013',
      sample: 'D',
      image: '/media/experimentations/013-D.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 46,
      series: '013',
      sample: 'E',
      image: '/media/experimentations/013-E.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 47,
      series: '013',
      sample: 'F',
      image: '/media/experimentations/013-F.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 48,
      series: '013',
      sample: 'G',
      image: '/media/experimentations/013-G.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 49,
      series: '013',
      sample: 'H',
      image: '/media/experimentations/013-H.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 50,
      series: '013',
      sample: 'I',
      image: '/media/experimentations/013-I.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 51,
      series: '013',
      sample: 'J',
      image: '/media/experimentations/013-J.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 52,
      series: '014',
      sample: 'A',
      image: '/media/experimentations/014-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 53,
      series: '014',
      sample: 'B',
      image: '/media/experimentations/014-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 54,
      series: '014',
      sample: 'C',
      image: '/media/experimentations/014-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 55,
      series: '014',
      sample: 'D',
      image: '/media/experimentations/014-D.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 56,
      series: '014',
      sample: 'E',
      image: '/media/experimentations/014-E.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 57,
      series: '015',
      sample: 'A',
      image: '/media/experimentations/015-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 58,
      series: '015',
      sample: 'B',
      image: '/media/experimentations/015-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 59,
      series: '015',
      sample: 'C',
      image: '/media/experimentations/015-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 60,
      series: '015',
      sample: 'D',
      image: '/media/experimentations/015-D.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 61,
      series: '016',
      sample: 'A',
      image: '/media/experimentations/016-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 62,
      series: '016',
      sample: 'B',
      image: '/media/experimentations/016-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 63,
      series: '016',
      sample: 'C',
      image: '/media/experimentations/016-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 64,
      series: '016',
      sample: 'D',
      image: '/media/experimentations/016-D.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 65,
      series: '016',
      sample: 'E',
      image: '/media/experimentations/016-E.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 66,
      series: '017',
      sample: 'A',
      image: '/media/experimentations/017-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 67,
      series: '017',
      sample: 'B',
      image: '/media/experimentations/017-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 68,
      series: '017',
      sample: 'C',
      image: '/media/experimentations/017-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 69,
      series: '017',
      sample: 'D',
      image: '/media/experimentations/017-D.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 70,
      series: '018',
      sample: 'A',
      image: '/media/experimentations/018-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 71,
      series: '018',
      sample: 'B',
      image: '/media/experimentations/018-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 72,
      series: '018',
      sample: 'C',
      image: '/media/experimentations/018-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 73,
      series: '018',
      sample: 'D',
      image: '/media/experimentations/018-D.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 74,
      series: '019',
      sample: 'A',
      image: '/media/experimentations/019-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 75,
      series: '019',
      sample: 'B',
      image: '/media/experimentations/019-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 76,
      series: '019',
      sample: 'C',
      image: '/media/experimentations/019-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 77,
      series: '019',
      sample: 'D',
      image: '/media/experimentations/019-D.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 78,
      series: '019',
      sample: 'E',
      image: '/media/experimentations/019-E.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 79,
      series: '020',
      sample: 'A',
      image: '/media/experimentations/020-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 80,
      series: '020',
      sample: 'B',
      image: '/media/experimentations/020-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
        {
      id: 81,
      series: '020',
      sample: 'C',
      image: '/media/experimentations/020-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 82,
      series: '020',
      sample: 'D',
      image: '/media/experimentations/020-D.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 82,
      series: '021',
      sample: 'A',
      image: '/media/experimentations/021-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 83,
      series: '021',
      sample: 'B',
      image: '/media/experimentations/021-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 84,
      series: '021',
      sample: 'C',
      image: '/media/experimentations/021-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 85,
      series: '021',
      sample: 'D',
      image: '/media/experimentations/021-D.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 86,
      series: '022',
      sample: 'A',
      image: '/media/experimentations/022-A.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 87,
      series: '022',
      sample: 'B',
      image: '/media/experimentations/022-B.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 88,
      series: '022',
      sample: 'C',
      image: '/media/experimentations/022-C.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
    {
      id: 89,
      series: '022',
      sample: 'D',
      image: '/media/experimentations/022-D.png',
      imageMere: '/api/placeholder/500/300',
      context: "Première injection de fragments abstraits produits sur TouchDesigner interprétés par I.A. et déclinés en nouveaux spécimens. Exploration d'une arborescence de mutation et des transformations opérées dans ce contexte. Le prompt joue sur les textures, les substances et les semblances. " , 
      seriesTheme: 'Formes Organiques',
      promptImages: ['/media/experimentations/Sample_14.jpg', '/media/experimentations/Sample_15.jpg'],
      promptText : 'a blob like iced planet',
      observation: "Les attributs 'blob' et 'like' apportent une souplesse dans l'interprétation et l'émergence des formes, de plus amples variations. Orienter la création de textures vers un environnement glacial provoque une hybridation de formes virtuelles et organiques.",
      aiModel: 'Gemini / DeFooocus_colab.ipynb',
      date: '19/05/2025 - 17h07'
    },
  ];

  // Initialiser avec le premier élément
  useEffect(() => {
    if (experiments.length > 0 && !selectedExperiment) {
      setSelectedExperiment(experiments[0]);
      setDisplayedImage(experiments[0].image);
    }
  }, [experiments, selectedExperiment]);

  // Gérer le scroll du carousel pour la scrollbar
  useEffect(() => {
    const handleScroll = () => {
      const carousel = carouselRef.current;
      if (carousel) {
        const scrollTop = carousel.scrollTop;
        const scrollHeight = carousel.scrollHeight;
        const clientHeight = carousel.clientHeight;
        const maxScroll = scrollHeight - clientHeight;
        const progress = maxScroll > 0 ? scrollTop / maxScroll : 0;
        
        setScrollProgress(progress);
      }
    };

    const carousel = carouselRef.current;
    if (carousel) {
      carousel.addEventListener('scroll', handleScroll);
      handleScroll();
      return () => carousel.removeEventListener('scroll', handleScroll);
    }
  }, []);

  // Fonction pour centrer le carousel sur un élément sélectionné
  const scrollToExperiment = (experimentId) => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    const experimentIndex = experiments.findIndex(exp => exp.id === experimentId);
    if (experimentIndex === -1) return;

    // Calculer la position approximative de l'élément
    const itemHeight = 210; // hauteur item + margin
    const containerHeight = carousel.clientHeight;
    const targetPosition = (experimentIndex * itemHeight) - (containerHeight / 2) + (itemHeight / 2);

    carousel.scrollTo({
      top: Math.max(0, targetPosition),
      behavior: 'smooth'
    });
  };

  const handleExperimentClick = (experiment) => {
    setSelectedExperiment(experiment);
    setDisplayedImage(experiment.image);
    setHighlightedSeries(null);
    
    // Si on est dans le tableau de bord, on le ferme et on centre le carousel
    if (isDashboardOpen) {
      setIsDashboardOpen(false);
      // Attendre que l'animation de fermeture se termine avant de scroller
      setTimeout(() => {
        scrollToExperiment(experiment.id);
      }, 300);
    }
  };

  const handleShowSisterSamples = () => {
    if (selectedExperiment) {
      setHighlightedSeries(selectedExperiment.series);
    }
  };

  const handleResetHighlight = () => {
    setHighlightedSeries(null);
  };

  const handlePromptImageHover = (imageSrc) => {
    setDisplayedImage(imageSrc);
  };

  const handlePromptImageLeave = () => {
    if (selectedExperiment) {
      setDisplayedImage(selectedExperiment.image);
    }
  };

  const getExperimentState = (experiment) => {
    const isSelected = selectedExperiment && experiment.id === selectedExperiment.id;
    const isSister = highlightedSeries && experiment.series === highlightedSeries && experiment.id !== selectedExperiment?.id;
    const isHovered = hoveredExperiment && experiment.id === hoveredExperiment.id;

    if (isSelected) return 'selected';
    if (isSister) return 'sister';
    if (isHovered) return 'hovered';
    return 'default';
  };

  // Fonction pour faire défiler vers une position spécifique
  const scrollToPosition = (percentage) => {
    const carousel = carouselRef.current;
    if (carousel) {
      const maxScroll = carousel.scrollHeight - carousel.clientHeight;
      const targetScroll = maxScroll * percentage;
      carousel.scrollTo({
        top: targetScroll,
        behavior: 'smooth'
      });
    }
  };

  // Gestion du drag de la scrollbar
  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleMouseMove = (e) => {
    if (!isDragging || !scrollbarRef.current) return;
    
    const rect = scrollbarRef.current.getBoundingClientRect();
    const y = e.clientY - rect.top;
    const percentage = Math.max(0, Math.min(1, y / rect.height));
    
    const carousel = carouselRef.current;
    if (carousel) {
      const maxScroll = carousel.scrollHeight - carousel.clientHeight;
      const targetScroll = maxScroll * percentage;
      carousel.scrollTop = targetScroll;
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // Fonction pour toggleer le tableau de bord
  const toggleDashboard = () => {
    setIsDashboardOpen(!isDashboardOpen);
  };

  // Event listeners globaux pour le drag
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'grabbing';
      document.body.style.userSelect = 'none';
      
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
      };
    }
  }, [isDragging]);

  return (
    <div className="experimentations-lab-container">
      <NavigationMenu />
      <LogoBlanc />
      
      <div className="page-title">
        <p className="title-text">Arborescence des fragments</p>
      </div>

      {/* Bouton tableau de bord */}
      <div className="dashboard-toggle" onClick={toggleDashboard}>
        <div className="dashboard-icon">
          <div className="grid-icon">
            <div className="grid-cell"></div>
            <div className="grid-cell"></div>
            <div className="grid-cell"></div>
            <div className="grid-cell"></div>
            <div className="grid-cell"></div>
            <div className="grid-cell"></div>
            <div className="grid-cell"></div>
            <div className="grid-cell"></div>
            <div className="grid-cell"></div>
          </div>
        </div>
        <span className="dashboard-label">Tableau de bord<br/>des échantillons</span>
      </div>

      {/* Tableau de bord pop-up */}
      {isDashboardOpen && (
        <div className="dashboard-overlay">
          <div className="dashboard-container">
            <div className="dashboard-header">
              <h2 className="dashboard-title">Tableau de Bord des Échantillons</h2>
              <button className="dashboard-close" onClick={toggleDashboard}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            
            <div className="dashboard-grid">
              {experiments.map((experiment) => (
                <div
                  key={experiment.id}
                  className={`dashboard-item ${selectedExperiment && experiment.id === selectedExperiment.id ? 'dashboard-item--selected' : ''}`}
                  onClick={() => handleExperimentClick(experiment)}
                >
                  <img
                    className="dashboard-image"
                    src={experiment.image}
                    alt={`${experiment.series}-${experiment.sample}`}
                  />
                  <div className="dashboard-item-info">
                    <span className="dashboard-item-ref">
                      {experiment.series}-{experiment.sample}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="main-grid">
        <div className="detail-panel">
          {selectedExperiment && (
            <div className="detail-content">
              {/* Header avec titre et contrôles */}
              <div className="detail-header">
                <div className="experiment-info">
                  <h2 className="experiment-title">
                    {selectedExperiment.title}
                  </h2>
                  <div className="experiment-meta">
                    <span className="experiment-reference">
                      SÉRIE {selectedExperiment.series} - ÉCHANTILLON {selectedExperiment.sample}
                    </span>
                    <span className="experiment-theme">

                    </span>
                  </div>
                </div>

                <div className="series-controls">
                  <button
                    className="series-button"
                    onClick={handleShowSisterSamples}
                  >
                    Voir échantillons de la série
                  </button>
                  {highlightedSeries && (
                    <button
                      className="reset-button"
                      onClick={handleResetHighlight}
                    >
                      Réinitialiser
                    </button>
                  )}
                </div>
              </div>

              {/* Contenu principal */}
              <div className="detail-main">
                {/* Colonne gauche - Images */}
                <div className="images-section">
                  <div className="main-image-container">
                    <img
                      className="main-image"
                      src={displayedImage || selectedExperiment.image}
                      alt={selectedExperiment.title}
                    />
                  </div>
                </div>

                {/* Colonne droite - Métadonnées */}
                <div className="metadata-section">
                  {/* Contexte */}
                  <div className="metadata-block">
                    <h3 className="metadata-title">
                      Contexte d'Expérimentation
                    </h3>
                    <p className="metadata-text">
                      {selectedExperiment.context}
                    </p>
                  </div>

                  {/* Métadonnées techniques */}
                  <div className="metadata-block">
                    <h3 className="metadata-title">
                      Données Techniques
                    </h3>
                    <div className="technical-data">
                      <div className="data-row">
                        <span className="data-label">Modèle IA:</span>
                        <span className="data-value">{selectedExperiment.aiModel}</span>
                      </div>
                      <div className="data-row">
                        <span className="data-label">Date:</span>
                        <span className="data-value">{selectedExperiment.date}</span>
                      </div>
                      <div className="data-row">
                        <span className="data-label">Réf. série:</span>
                        <span className="data-reference">
                          {selectedExperiment.series}-{selectedExperiment.sample}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Images prompts */}
                  <div className="metadata-block prompt-images-block">
                    <h3 className="metadata-title">
                      Images Prompts
                    </h3>
                    <div className="prompt-images-grid">
                      {selectedExperiment.promptImages.map((img, index) => (
                        <img
                          key={index}
                          className="prompt-image"
                          src={img}
                          alt={`Prompt ${index + 1}`}
                          onMouseEnter={() => handlePromptImageHover(img)}
                          onMouseLeave={handlePromptImageLeave}
                        />
                      ))}
                    </div>
                  </div>

                  {/* Prompt textuel */}
                  <div className="metadata-block">
                    <h3 className="metadata-title">
                      Prompt Textuel
                    </h3>
                    <div className="prompt-text-container">
                      <p className="prompt-text">
                        {selectedExperiment.promptText}
                      </p>
                    </div>
                  </div>

                  {/* Observations */}
                  <div className="metadata-block">
                    <h3 className="metadata-title">
                      Observations
                    </h3>
                      <p className="metadata-text">
                        {selectedExperiment.observation}
                      </p>
                  </div>
                  
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Carousel vertical */}
      <div className="carousel-container">
        <div 
          ref={scrollbarRef}
          className="carousel-scrollbar"
          onClick={(e) => {
            if (!isDragging) {
              const rect = e.currentTarget.getBoundingClientRect();
              const clickY = e.clientY - rect.top;
              const percentage = clickY / rect.height;
              scrollToPosition(percentage);
            }
          }}
        >
          <div 
            className="scrollbar-indicator" 
            style={{
              top: `${Math.min(scrollProgress * 80, 80)}%`,
              height: '20%',
              opacity: 1,
              display: 'block',
              cursor: isDragging ? 'grabbing' : 'grab'
            }}
            onMouseDown={handleMouseDown}
          />
        </div>

        <div ref={carouselRef} className="carousel-content">
          {experiments.map((experiment) => {
            const state = getExperimentState(experiment);
            return (
              <div
                key={experiment.id}
                className={`carousel-item carousel-item--${state}`}
                onClick={() => handleExperimentClick(experiment)}
                onMouseEnter={() => setHoveredExperiment(experiment)}
                onMouseLeave={() => setHoveredExperiment(null)}
              >
                <img
                  className="carousel-image"
                  src={experiment.image}
                  alt={`${experiment.series}-${experiment.sample}`}
                />

                {/* Overlay hover */}
                {hoveredExperiment && hoveredExperiment.id === experiment.id && (
                  <div className="carousel-overlay">
                    <div className="experiment-badge">
                      <div className="badge-series">
                        SÉRIE {experiment.series}
                      </div>
                      <div className="badge-sample">
                        ÉCHANTILLON {experiment.sample}
                      </div>
                    </div>
                  </div>
                )}

                {/* Indicateur série */}
                <div className="series-indicator">
                  {experiment.series}-{experiment.sample}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LaboratoireSymbiotique;